import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const SelectBase = forwardRef(({ name, allowNull, hasError, isDefault, options, className = '', ...props }, ref) => {
  const sizeClass = className.match(/select-(xs|sm|md|lg)/) ? '' : 'select-sm';
  const widthClass = className.match(/w-/) ? '' : 'w-full';
  const variantClass = className.includes('select-ghost') ? '' : 'select-bordered';

  return (
    <select
      id={name}
      ref={ref}
      name={name}
      className={`select ${variantClass} ${sizeClass} ${widthClass} ${!isDefault ? 'font-bold placeholder-shown:font-normal' : ''} ${hasError ? 'input-error' : ''} ${className}`}
      {...props}
    >
      {allowNull && <option value=""></option>}
      {options.map(option => (
        <option value={option.value} key={`${name}-${option.value}`}>
          {option.label || option.value}
        </option>
      ))}
    </select>
  );
});

SelectBase.propTypes = {
  name: PropTypes.string,
  allowNull: PropTypes.bool,
  isDefault: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  className: PropTypes.string,
};

SelectBase.displayName = 'SelectBase';

export default SelectBase;
